import {createI18n} from "vue-i18n";
import zh from "./zh";
import en from "./en";
import Cookies from 'js-cookie'

Cookies.get("lang")===undefined?Cookies.set("lang",'zh'):''

const i18n = createI18n({
	legacy:false,
	globalInjection:true,
	locale:Cookies.get("lang"),
	messages:{
		zh,
		en
	}
})

export default i18n;